export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ed854cd4271a853001a2b990d1a7c2d537e43f7f&name=pushAdClickData!'